import request from "@/request"
import { getToken } from "@/request/token"

const difyBaseURL = process.env.NODE_ENV === "production"
  // ? "http://120.48.53.21:9529/base/base"
  ? "/api"
  : "/api"

/**
 * 会话历史列表（分页）
 */
export function getConversationHistory(data) {
  return request({
    url: "/difyChat/history/conversations",
    method: "POST",
    data
  })
}

/**
 * 某个会话的历史消息
 */
export function getConversationMessages(data) {
  return request({
    url: "/difyChat/history/messages",
    method: "POST",
    data
  })
}

/**
 * 快捷提问（后端配置下发）
 */
export function getQuickSuggestions(data) {
  return request({
    url: "/difyChat/suggestions",
    method: "POST",
    data
  })
}

/**
 * 路由预判，仅用于开发态调试，不代表 Dify 实际命中结果。
 */
export function getRoutePreview(data) {
  return request({
    url: "/difyChat/routePreview",
    method: "POST",
    data
  })
}

function emitPayload(raw, onMessage) {
  if (!raw || raw === "[DONE]") {
    return
  }
  const payload = JSON.parse(raw)
  if (typeof onMessage === "function") {
    onMessage(payload)
  }
}

/**
 * 流式发送消息，兼容 NDJSON 与 SSE(data: xxx) 两种返回格式
 */
export async function streamSendMessage(data, { onMessage, signal } = {}) {
  const response = await fetch(`${difyBaseURL}/difyChat/sendMsgToStreamChat`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: getToken() || ""
    },
    body: JSON.stringify(data),
    signal
  })

  if (!response.ok) {
    throw new Error(`请求失败: ${response.status}`)
  }
  if (!response.body) {
    return
  }

  const reader = response.body.getReader()
  const decoder = new TextDecoder("utf-8")
  let buffer = ""

  let reading = true
  while (reading) {
    const { done, value } = await reader.read()
    buffer += decoder.decode(value || new Uint8Array(), { stream: !done })

    const lines = buffer.split(/\r?\n/)
    buffer = lines.pop() || ""

    lines.forEach((line) => {
      const text = line.trim()
      if (!text || text.startsWith("event:")) {
        return
      }
      const payloadText = text.startsWith("data:") ? text.slice(5).trim() : text
      try {
        emitPayload(payloadText, onMessage)
      } catch (error) {
        buffer = `${payloadText}${buffer}`
      }
    })

    reading = !done
  }

  const tail = buffer.trim()
  if (tail) {
    emitPayload(tail.startsWith("data:") ? tail.slice(5).trim() : tail, onMessage)
  }
}
